import { createTheme } from "@mui/material";

export const palette = {
  background: {
    default: "#FBFBFD",
  },
  primary: {
    main: "rgb(158, 119, 237)",
    light: "#7986CB",
    dark: "rgb(105,65,198)",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#F50057",
  },
  text: {
    primary: "#212121",
    secondary: "#666666",
    disabled: "#9E9E9E",
  },
  action: {
    active: "rgba(33, 35, 51, 0.5)",
    hover: "rgba(0, 0, 0, 0.04)",
    disabled: "rgba(0, 0, 0, 0.26)",
    disabledBackground: "rgba(0, 0, 0, 0.12)",
  },
  divider: "rgba(0, 0, 0, 0.12)",
  error: {
    main: "#F50057",
  },
  warning: {
    main: "#FF9800",
    contrastText: "#FFFFFF",
  },
};

export const theme = createTheme({
  palette,
  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
  },
});
